// Don't reorder!
export enum PasFeature {
	BUY_FUNDS,
	COMPARE,
	TRANSIENT_ANALYSIS,
	WORST_TAX_OFFENDERS,
	FUNDS_TO_EXPLORE
}

